export default {
  SYSTEM_ADMIN: 0,
  ENTERPRISE_ADMIN: 1,
  NORMAL_USER: 2,
};



// WEBPACK FOOTER //
// ./src/manage-modules/AuditLog/_data/UserType.js